<template>
  <v-dialog v-model="dialog" width="350">
    <v-card>
      <v-card-title>
        Editar projeto
        <v-spacer></v-spacer>
        <v-menu bottom left v-if="data && data.role === 'Administrador'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="modalDestroy = true">
              <v-list-item-title>Apagar projeto</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-card-text class="pt-6 pb-1">
        <v-text-field
          v-model="form.name"
          label="Nome do projeto"
          outlined
          hide-details
        ></v-text-field>
        <zp-select-domain
          v-if="data"
          class="mt-5"
          v-model="form.domain_id"
          :user_id="data.user_id"
        ></zp-select-domain>
        <zp-pixel-select
          class="mt-5"
          v-model="form.pixels"
          label="Pixels"
          placeholder="Selecione"
          :multiple="true"
        ></zp-pixel-select>
        <v-text-field
          class="mt-5"
          label="WhatsApp padrão"
          placeholder="+00 00 00000-0000"
          v-model="form.phone"
          outlined
          hide-details
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="pr-5 pl-5 pb-5 pt-6">
        <v-btn color="secondary" depressed light block :loading="loading" @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <zp-alert-modal v-model="modalDestroy" icon="/img/alert/alert.svg" @ok="destroy()" cancel>
      <div class="d-flex flex-column">
        <h3>Pense bem!</h3>
        <span class="mt-2">Você tem certeza que desejar apagar o projeto? Ao prosseguir, todos os links vinculados à ele serão removidos. Esta ação não pode ser desfeita.</span>
      </div>
    </zp-alert-modal>
  </v-dialog>
</template>

<script>
import ZpSelectDomain from '@/components/SelectDomain'
import ZpPixelSelect from '@/components/Pixel/Select'
import ZpAlertModal from '@/components/AlertModal.vue'

export default {
  props: ['data'],
  components: {
    ZpSelectDomain,
    ZpPixelSelect,
    ZpAlertModal
  },
  data () {
    return {
      form: {
        name: '',
        pixels: [],
        phone: '',
        domain_id: null
      },
      modalDestroy: false,
      loading: false,
      dialog: false,
      domains: []
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: async function (data) {
        this.dialog = !!data

        if (data) {
          this.form.name = data.name
          this.form.phone = data.phone || ''
          this.form.pixels = data.pixels || []
          this.form.domain_id = data.domain_id || null
        }

        if (!this.dialog) {
          this.onClose()
          this.form = {
            name: '',
            pixels: [],
            phone: '',
            domain_id: null
          }
        }
      }
    },
    dialog: function (dialog) {
      if (!dialog && this.data) {
        this.onClose()
      }
    }
  },
  methods: {
    async save () {
      this.loading = true
      try {
        await this.$store.dispatch('projects/update', {
          id: this.data.id,
          data: {
            ...this.form,
            pixels: this.form.pixels.map(item => item.id),
            domain_id: this.form.domain_id || null
          }
        })
        this.onClose()
      } catch (e) {
        alert(e.message)
      }
      this.loading = false
    },
    onClose () {
      this.dialog = false
      this.$emit('close')
    },
    async destroy () {
      this.loading = true

      try {
        await this.$store.dispatch('projects/destroy', this.data.id)
        this.onClose()
      } catch (e) {
        alert(e.message)
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
